import { CallStateEnum } from '@shared/models/call-state.model';
import { GroupSettingsGet } from './group-settings.model';

export const callStateStatusSlice = (getState: GroupSettingsGet) => ({
  isScreensLoading: () => getState().screensCallState === CallStateEnum.Loading,

  isPlaylistsLoading: () =>
    getState().playlistsCallState === CallStateEnum.Loading,

  isDevicesLoading: () =>
    [CallStateEnum.Init, CallStateEnum.Loading].includes(
      getState().devicesCallState
    ) || getState().groupDetailsCallState === CallStateEnum.Loading
});
